import { Flex, ListItem } from '@modusign/design-system';
import { ReactNode } from 'react';

function OrderBadge({ children }: { children: ReactNode }) {
  return (
    <Flex
      alignItems="center"
      backgroundColor="statusBackgroundNeutralBase"
      borderRadius={10}
      color="textNeutralDark"
      fontSize="10px"
      height="20px"
      justifyContent="center"
      width="20px"
    >
      {children}
    </Flex>
  );
}

export default function DescriptionListItem({
  index,
  children,
}: {
  index: number;
  children: ReactNode;
}) {
  return (
    <ListItem display="flex" ml={0} sx={{ alignItems: 'center', gap: 2, listStyle: 'none' }}>
      <OrderBadge>{index + 1}</OrderBadge>
      {children}
    </ListItem>
  );
}
